import { render, staticRenderFns } from "./tablefooter.vue?vue&type=template&id=cccf890a"
import script from "./tablefooter.vue?vue&type=script&lang=js"
export * from "./tablefooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports